<template>
  <div>
    <b-form-group
      v-for="(field, index) in conditionFields"
      :key="index"
      :label="field.label"
      class="dropdownModuleFields w-100"
      label-for="awaitType"
      label-cols-md="12"
    >
      <select-field
        v-if="field.type === 'select'"
        :select-model="field.value"
        :select-options="field.options"
        :field="field"
      />
      <input-type
        v-if="field.type === 'string'"
        :select-model="field.value"
      />
      <number-input-type
        v-if="field.type === 'number'"
        :select-model="field.value"
      />
      <date-type
        v-if="field.type === 'date'"
        :select-model="field.value"
      />
      <boolean-type
        v-if="field.type === 'boolean'"
        :select-model="field.value"
      />
    </b-form-group>
  </div>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import InputType from './InputType.vue'
import SelectField from './SelectField.vue'
import DateType from './DateType.vue'
import NumberInputType from './NumberInputType.vue'
import BooleanType from './BooleanType.vue'

export default {
  components: {
    BFormGroup,
    BooleanType,
    InputType,
    DateType,
    SelectField,
    NumberInputType,
  },
  props: {
    conditionFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
}
</script>

            <style lang="scss">
            </style>
